<template>
  <div>
    <div style="width: 20cm; margin: 2mm auto">
      <el-button class="printBtn" type="primary" @click="printHandle">打印</el-button>
    </div>
    <div id="print" :contentLoading="contentLoading">
      <div class="printItem">
        <!-- 标题区域 -->
        <div class="printTitle">
          <div class="printTitleLogo">
            <img class="company-logo" :src="$tenant.stepIcon">
            <div class="company-info">
              <div style="margin-bottom: 5px;">简称:新时达</div>
              <div>代码:002527</div>
            </div>
          </div>
          <div class="print-title">
            <div>新时达工控技术（杭州）有限公司</div>
            <div style="margin-top: 4px;">返修品发货单</div>
          </div>
          <div class="print-subtitle">
            <div>
              <span style="font-style: italic;">No.</span>
              <span style="font-weight: bold; color: #000;">{{productData.billNo}}</span>
            </div>
            <!-- <div style="margin-top: 5px;font-size: 12px;">第 1 页 / 共 1 页</div> -->
          </div>
        </div>
        <!-- 基本信息区域 -->
        <div class="baseInfo">
          <el-descriptions :column="9" :label-width="120">
            <el-descriptions-item :span="3" label="收货人">{{productData.consignee || ''}}</el-descriptions-item>
            <el-descriptions-item :span="3" label="联系电话">{{productData.consigneeContact || ''}}</el-descriptions-item>
            <el-descriptions-item :span="3" label="物流单号">{{productData.deliverCourierNO || ''}}</el-descriptions-item>
            <el-descriptions-item :span="4" label="收货单位">{{productData.customerName || ''}}</el-descriptions-item>
            <el-descriptions-item :span="5" label="地址">{{productData.customerAddress || ''}}</el-descriptions-item>
          </el-descriptions>
        </div>
        <!-- 产品信息区域 -->
        <table cellpadding="0" cellspacing="0" style="border: 1px solid #000;table-layout: fixed;">
          <!-- 表头 -->
          <tr>
            <td align="center" style="width: 40px; font-weight: bold;">序号</td>
            <td align="center" style="width: 200px; font-weight: bold;">物料代码</td>
            <td align="center" style="width: 200px;font-weight: bold;" width="120px;">规格型号</td>
            <!-- <td align="center" style="font-weight: bold;">数量</td> -->
            <td align="center" style="font-weight: bold;">备注</td>
          </tr>
  
          <!-- 明细数据 -->
          <tr v-for="(item, idx) in repairDetail" :key="item.pkid || idx">
            <td align="center">{{idx + 1}}</td>
            <td align="center">{{item.barcode || ''}}</td>
            <td align="center">{{item.specification || ''}}</td>
            <!-- <td align="center">{{item.quantity}}</td> -->
            <td align="center" width="100px;">
              <span class="display-value">{{item.jjNote}}</span>
              <input
                  v-model="item.jjNote"
                  placeholder="请输入"
                  class="table-input editable-input">
            </td>
          </tr>
        </table>
        <!--        &lt;!&ndash; 备注信息： &ndash;&gt;-->
        <!--        <div class="remark-box">-->
        <!--          <div style="font-weight: bold; margin-bottom: 5px;">备注信息：</div>-->
        <!--          <div>{{productData.jjNote || ''}}</div>-->
        <!--        </div>-->
        <!-- 底部签名区域 -->
        <div class="signature-box">
          <el-descriptions :column="3">
            <el-descriptions-item :span="2" label="发货人/日期">{{productData.deliverPeople || ''}}/{{productData.deliverTime || ''}}</el-descriptions-item>
            <el-descriptions-item label="收货人/日期"/>
          </el-descriptions>
          <div style="border-bottom: 1px solid #000;"/>
          <div class="print-footer">
            <span>第 {{productData.printCount || 1}} 次打印</span>
            <span>打印时间： {{new Date().toLocaleString()}}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

  <script>
  export default {
    data() {
      return {
        // ids: [],
        id: 0,
        contentLoading: false,
        repairDetail: [],
        productData: {
          repairType: "",
          billNo: "",
          terminalCustomerName: "",
          consigneeContact : "",
          deliverCourierNO : "",
          customerName: "",
          customerAddress: "",
          note: "",
          deliverPeople: "",
          deliverTime: "",
          printCount: 1,
        },
      };
    },

    mounted() {
      this.getData(JSON.parse(this.$route.query.params));
    },
    methods: {
      getData(ids) {
        if (!ids) return;
        this.contentLoading = true;
        this.$http.put("basic", "repairRegistrations/getListByBatch", ids).then((resp) => {
          const data = resp.data;
          if (!data || data.length === 0) {
            this.$message.error("未查询到数据");
            return;
          }
          // 填充基本信息
          this.productData = data[0];
          
          // 填充明细
          this.repairDetail = data;
          this.repairDetail.forEach(item => {
            this.$set(item, "jjNote", item.jjNote);
          });
        })
          .finally(() => {
            this.contentLoading = false;
          });
      },

      printHandle() {
        document.body.innerHTML = document.getElementById("print").parentNode.innerHTML;
        window.print();
        window.close();
      },
    },
  };
  </script>

  <style lang="scss" scoped>
  .printItem {
    width: 20cm;
    border: 1px solid #000;
    font-size: 11pt;
    margin: 10px auto;
    page-break-after: always;
    padding: 15px 5px;
    font-family: "Microsoft YaHei", "SimHei", "Arial", sans-serif; // 使用更清晰的中文字体
    color: #000; // 确保黑色打印
    .printTitle{
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 10px;
      position: relative;
      font-size: 13pt;
      height:80px;
      .printTitleLogo{
        display: flex;
        align-items: center;
        flex: 1;
      }
      .company-logo{
        width: 80px;
      }
      .company-info{
        font-size: 12pt;
        line-height: 12pt;
        padding-left: 5px;
        margin-left: 5px;
        color: #000;
        border-left: 1px solid #000;
      }
      .print-title{
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        text-align: center;
        font-size: 14pt;
        font-weight: bold;
        align-items: center;
      }
      .print-subtitle{
        flex: 1;
        text-align: right;
      }
    }
    table {
      width: 100%;
      border-collapse: collapse;
      margin-bottom: 3px;
      tr {
        td {
          border-bottom: 1px solid #000;
          border-right: 1px solid #000;
          padding: 2px;
          min-width: 40px;
          vertical-align: middle;
          font-size: 12pt;
          line-height: 1.2;
          &:last-child {
            border-right: none;
          }
        }
        &:last-child td {
          border-bottom: none;
        }
      }
    }
    .remark-box{
      border: 1px solid #000;
      padding: 2px 5px;
      font-size: 12pt;
      line-height: 1.5;
      min-height: 30px;
      margin-bottom: 20px;
    }
    .print-footer{
      font-size: 12pt;
      line-height: 1.5;
      color: #000;
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
  }

  ::v-deep .el-descriptions--mini{
    font-size: 12pt;
    border-color: #000;
    .el-descriptions__body{
      font-family: "Microsoft YaHei", "SimHei", "Arial", sans-serif; // 使用更清晰的中文字体
      color: #000; // 确保黑色打印
      font-weight: 600; // 确保字体粗细适中
      border-color: #000;
    }
  }
  ::v-deep .el-descriptions__body{
    font-family: "Microsoft YaHei", "SimHei", "Arial", sans-serif; // 使用更清晰的中文字体
    color: #000; // 确保黑色打印
    font-weight: 600; // 确保字体粗细适中
    color: #000;
    border-color: #000;
  }

  /* 隐藏显示标签，在打印时显示纯文本 */
  .display-value {
    display: none;
  }

  /* 打印时隐藏输入框边框，显示为普通文本 */
  .editable-input {
    background: transparent;
    box-shadow: none;
    padding: 0;
    width: auto;
    display: inline;
    font-family: inherit;
    font-size: inherit;
    &:focus{
      outline: none;
    }
  }
  
  /* 打印时表格输入框样式 */
  .table-input {
    background: transparent;
    box-shadow: none;
    padding: 0;
    width: 100%;
    text-align: center;
    font-family: inherit;
    font-size: inherit;
  }

  @media print {
    .printBtn,.editable-input {
      display: none;
    }
    .display-value{
      display: initial !important;
    }
    .printItem {
      border: none;
      margin: 10px 3px;
      table {
        tr {
          td {
            border-bottom: 1px solid #000;
            border-right: 1px solid #000;
          }
        }
      }
    }

    @page{
       counter-increment: page;
      @bottom-center{
        font-size: 10pt;
        color: #000;
        content: "第 " counter(page) " 页 共 " counter(pages) " 页";
      }
    }
  }
  </style>
